(() => {
  const placeholderText = new Set([
    'Powermeter', 'XXE', 'SIGEYI', 'Wheels', 'Fitelite', 'Crank',
    'Accessories', 'Customize Cycling Tour Plan', 'Customize Your Own Bike'
  ]);
  const trustLinks = [
    ['Quote process', '/pages/how-quote-requests-work'],
    ['Shipping', '/pages/shipping-delivery'],
    ['Returns & warranty', '/pages/returns-warranty'],
    ['About', '/pages/about-velo-atlas']
  ];
  const disclaimerText = 'Velo Atlas is an independent sourcing service. Brand names, logos, and trademarks are used only to identify compatible or requested products. Velo Atlas is not affiliated with, sponsored by, or endorsed by these brands unless expressly stated.';
  const hasQuoteSuccess = /(?:^|&)contact_posted=true(?:&|$)/.test(window.location.search.slice(1));
  let quoteSuccessFocused = false;

  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const priceUiPattern = /^(price|价格)$|price, low to high|price, high to low|sort by price|按价格/i;
  const sameStorePath = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      return url.origin === window.location.origin ? url.pathname : '';
    } catch (error) {
      return '';
    }
  };
  const hide = (el) => {
    if (!el) return;
    el.classList?.add('va-hidden-price-ui');
    el.setAttribute?.('hidden', 'hidden');
    if (el.style) el.style.display = 'none';
  };
  const closestPriceBlock = (node) => node?.closest('details, fieldset, form, .facets__disclosure, .facets__item, .facets__price, .filter, .filter-group, .accordion, li, option, select, div');

  function quotePanel() {
    return document.querySelector('#request-quote');
  }

  function createNotice(className, title, body) {
    const notice = document.createElement('div');
    notice.className = className;
    notice.setAttribute('role', className.includes('success') ? 'status' : 'note');
    notice.innerHTML = `<strong>${title}</strong><span>${body}</span>`;
    return notice;
  }

  function addQuoteConfidence() {
    const panel = quotePanel();
    if (!panel) return;
    if (!panel.querySelector('.va-quote-confidence')) {
      const note = createNotice(
        'va-quote-confidence',
        'Live quote with full landed-cost follow-up.',
        'Frame costs move with warehouse availability, freight, duties/taxes, and currency. Send the form and we will confirm current product price, shipping, import costs where applicable, and ETA by email within 1-2 business days.'
      );
      const form = panel.querySelector('form');
      if (form) form.insertAdjacentElement('beforebegin', note);
      else panel.prepend(note);
    }
    if (!panel.querySelector('.va-sourcing-disclaimer')) {
      const disclaimer = document.createElement('p');
      disclaimer.className = 'va-sourcing-disclaimer';
      disclaimer.textContent = disclaimerText;
      const form = panel.querySelector('form');
      if (form) form.insertAdjacentElement('afterend', disclaimer);
      else panel.appendChild(disclaimer);
    }
  }

  function showQuoteSuccess() {
    if (!hasQuoteSuccess) return;
    const panel = quotePanel() || document.querySelector('main');
    if (!panel || panel.querySelector('.va-quote-success')) return;
    const notice = createNotice(
      'va-quote-success',
      'Quote request sent.',
      'Thank you. We received your request and will reply by email within 1-2 business days with current availability, product price, shipping, and import duties/taxes where applicable.'
    );
    notice.setAttribute('tabindex', '-1');
    panel.prepend(notice);
    if (!quoteSuccessFocused) {
      quoteSuccessFocused = true;
      window.setTimeout(() => {
        notice.focus({ preventScroll: true });
        notice.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 250);
    }
  }

  function trackQuoteSubmit() {
    const panel = quotePanel();
    if (!panel) return;
    panel.querySelectorAll('form').forEach((form) => {
      if (form.dataset.vaQuoteTracked) return;
      form.dataset.vaQuoteTracked = 'true';
      form.addEventListener('submit', () => {
        if (panel.querySelector('.va-quote-pending')) return;
        const pending = createNotice(
          'va-quote-pending',
          'Sending your quote request...',
          'Please wait a moment. A confirmation message will appear after Shopify accepts the request.'
        );
        form.insertAdjacentElement('beforebegin', pending);
      });
    });
  }

  function polishNavigation() {
    document.querySelectorAll('a[href]').forEach((anchor) => {
      const label = clean(anchor.textContent || anchor.getAttribute('aria-label'));
      const path = sameStorePath(anchor.getAttribute('href'));
      if (label === 'Frameset' && path === '/') anchor.setAttribute('href', '/collections/road-framesets');
      if (label === 'Components' && path === '/collections') anchor.setAttribute('href', '/collections/accessories-small-parts');
      if (placeholderText.has(label) && path === '/') {
        anchor.classList.add('va-hidden-placeholder-nav');
        const item = anchor.closest('li');
        if (item) item.classList.add('va-hidden-placeholder-nav');
      }
    });
  }

  function hideCartEntrances() {
    document.querySelectorAll("a[href*='/cart'], button[name='checkout'], cart-icon, .cart-count-bubble").forEach((el) => {
      el.classList.add('va-hidden-cart-ui');
    });
  }

  function rewriteQuoteAccountLinks() {
    const panel = quotePanel();
    if (!panel) return;
    const returnUrl = `${window.location.pathname}${window.location.search}#request-quote`;
    panel.querySelectorAll('a').forEach((anchor) => {
      const label = clean(anchor.textContent).toLowerCase();
      if (!label.includes('sign in') && !label.includes('create account')) return;
      const target = label.includes('create') ? '/account/register' : '/account/login';
      const desired = `${target}?return_url=${encodeURIComponent(returnUrl)}`;
      if (anchor.getAttribute('href') !== desired) anchor.setAttribute('href', desired);
    });
  }

  function scrubPriceControls() {
    document.querySelectorAll('select option, option').forEach((option) => {
      const value = `${option.value} ${option.textContent}`;
      if (priceUiPattern.test(clean(value)) || /price/i.test(value)) {
        option.disabled = true;
        option.hidden = true;
        option.remove();
      }
    });
    document.querySelectorAll('select').forEach((select) => {
      Array.from(select.options).forEach((option) => {
        const value = `${option.value} ${option.textContent}`;
        if (priceUiPattern.test(clean(value)) || /price/i.test(value)) option.remove();
      });
      const selected = select.options[select.selectedIndex];
      if (selected && /price|价格/i.test(`${selected.value} ${selected.textContent}`)) select.selectedIndex = 0;
    });
    document.querySelectorAll('input[name*="price"], input[id*="Price"], input[id*="price"], input[name*="filter.v.price"]').forEach((input) => {
      hide(input.closest('details, fieldset, form, .facets__price, .facets__disclosure, .filter-group') || closestPriceBlock(input));
    });
    document.querySelectorAll('summary, button, label, span').forEach((node) => {
      if (priceUiPattern.test(clean(node.textContent))) {
        hide(node.closest('details, fieldset, .facets__disclosure, .filter-group, li, div') || node);
      }
    });
  }

  function polishHome() {
    const main = document.querySelector('main[data-template]');
    const isHome = window.location.pathname === '/' || (main && /^index/.test(main.dataset.template || ''));
    if (!isHome) return;

    document.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach((heading) => {
      const label = clean(heading.textContent);
      if (label === 'Ride Beyond Limits' || label === 'Velo Atlas Quote Desk') {
        heading.textContent = 'Velo Atlas Quote Desk';
        let subcopy = heading.parentElement.querySelector('.va-home-subcopy');
        if (!subcopy) {
          subcopy = document.createElement('span');
          subcopy.className = 'va-home-subcopy';
          heading.insertAdjacentElement('afterend', subcopy);
        }
        subcopy.textContent = 'Premium road framesets from Cervelo, Colnago, Pinarello, Specialized, Officine Mattio and more, with live warehouse pricing confirmed by email.';
      }
      if (label === 'Discounted Framesets') {
        const section = heading.closest('.shopify-section, section');
        if (section) section.classList.add('va-hidden-placeholder-nav');
      }
      if (label === 'Our Services') heading.textContent = 'Quote-first sourcing';
      if (label === 'Shipping') heading.textContent = 'Shipping confirmed by quote';
      if (label === 'Discover The World With Your Bike') heading.textContent = 'Build planning by email';
    });
    document.querySelectorAll('p').forEach((paragraph) => {
      const label = clean(paragraph.textContent);
      if (label === 'Join our cycling tours now!') {
        paragraph.textContent = 'Tell us the frame, size, destination, and build details. We confirm current availability before you commit.';
      }
    });
    document.querySelectorAll('a,button').forEach((el) => {
      if (clean(el.textContent) === 'Discover Now') el.textContent = 'View products';
      if (clean(el.textContent) === 'Discover More') el.textContent = 'Request advice';
    });
  }

  function addFooterTrustLinks() {
    const footer = document.querySelector('footer');
    if (!footer) return;
    if (!footer.querySelector('.va-footer-trust-links')) {
      const nav = document.createElement('nav');
      nav.className = 'va-footer-trust-links';
      nav.setAttribute('aria-label', 'Velo Atlas information pages');
      trustLinks.forEach(([label, href]) => {
        const a = document.createElement('a');
        a.textContent = label;
        a.href = href;
        nav.appendChild(a);
      });
      footer.appendChild(nav);
    }
    if (!footer.querySelector('.va-footer-sourcing-disclaimer')) {
      const disclaimer = document.createElement('p');
      disclaimer.className = 'va-footer-sourcing-disclaimer';
      disclaimer.textContent = disclaimerText;
      footer.appendChild(disclaimer);
    }
  }

  let queued = false;
  function run() {
    document.documentElement.classList.add('va-polish-ready');
    polishNavigation();
    hideCartEntrances();
    rewriteQuoteAccountLinks();
    addQuoteConfidence();
    showQuoteSuccess();
    trackQuoteSubmit();
    scrubPriceControls();
    polishHome();
    addFooterTrustLinks();
  }
  function queueRun() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  window.addEventListener('load', run, { once: true });
  [500, 1000, 2000, 4000, 8000, 12000].forEach((delay) => window.setTimeout(run, delay));
  new MutationObserver(queueRun).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'class', 'style'] });
})();
